export default "__VITE_ASSET__Blp5oyua__"